import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import PageContainer from "~/components/PageContainer";
import Loading from "~/pages/Loading";
import PageId from "~/utils/PageId";

export const Route = createFileRoute("/loading")({
  staticData: {
    pageId: PageId.LOADING,
    titleKey: "pageTitles.loading",
    hideNav: true,
  },
  component: LoadingRoute,
});

function LoadingRoute() {
  const { t } = useTranslation("common");
  return (
    <PageContainer title={t("pageTitles.loading")} hideNav>
      <Loading />
    </PageContainer>
  );
}
